export default {
    config: {
        defaultWidth: {
            default: 80,
            sheet: 160
        },
    },
    default: {
        label: 'Added'
    },
    unique: [],
    sort: 'collection.added',
    lang: {
        name: 'Date Added to Collection',
        category: ['User', 'Collection'],
        description: 'When the game was added to the collection.',
        views: ['list', 'sheet', 'grid'],
    },
    filters: ['collection.added']
}